const GOOGLE_BASE = process.env.GOOGLE_API_BASE;

const StoryService = {
  async getSheetData(opts = {}) {
    const {
      workbookId,
      accountId,
      sheetId,
      cache = true,
    } = opts;

    let url = `${GOOGLE_BASE}/sheets/${accountId}/${workbookId}/${sheetId}`;
    if (!cache) {
      url += '?cache=false';
    }

    const resp = await fetch(url, { mode: 'cors', credentials: 'include' });
    return resp.json();
  },

  async getSheetsFromWorkbook(opts = {}) {
    const {
      workbookId,
      accountId,
    } = opts;

    const url = `${GOOGLE_BASE}/sheets/${accountId}/${workbookId}`;
    const resp = await fetch(url, { mode: 'cors', credentials: 'include' });
    return resp.json();
  },

  /**
   * getPublicSheetData fetches public sheet data as xlsx, parses that data, and returns it
   * @param {string} opts.url - Public URL of the sheet to export
   * @param {bool} [opts.key] - Unique id to use for namespacing
   * @param {bool} [opts.force] - Force a refetch of the sheet instead of pulling from cache
   * @param {bool} [opts.sheet] - Name of the sheet to fetch data for
   * @returns {Object} - Sheets workbook
   */
  async getPublicSheetData(opts = {}) {
    const {
      url,
      key,
      force,
      sheet,
    } = opts;

    const query = {
      force,
      key,
      sheet,
      url,
    };

    const querystring = Object.keys(query)
      .filter((k) => query[k])
      .map((k) => `${k}=${encodeURIComponent(query[k])}`)
      .join('&');

    const resp = await fetch(`${GOOGLE_BASE}/sheets/url?${querystring}`, {
      mode: 'cors',
      credentials: 'include',
    });

    if (resp.status >= 300) {
      const data = await resp.json();
      const message = (data && data.message) ?? 'Sheet not found';
      throw new Error(message);
    }
    const data = await resp.json();
    return data?.workbook;
  },
};

export default StoryService;
